import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import posed from "react-pose";
import { ScreenHeader } from "../Layout";

const PoseOverlay = posed.div({
  open: {
    delayChildren: 250,
    staggerChildren: 50
  },
  closed: { delay: 500 }
});

const PoseItem = posed.div({
  open: { x: 0, opacity: 1 },
  closed: { x: 100, opacity: 0 }
});

class Weather extends PureComponent {
  static propTypes = {
    providers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired
      })
    ).isRequired,
    onSelect: PropTypes.func
  };

  static defaultProps = {
    onSelect: provider => {}
  };

  state = {
    isOpen: false
  };

  componentDidMount() {
    this.setState({ isOpen: true });
  }

  renderWeatherProvider = provider => {
    return (
      <PoseItem
        key={provider.id}
        className="weather-provider-item menu-list-item"
      >
        <a
          href="#open-weather"
          role="button"
          className="provider-wrap"
          onClick={event => {
            event.preventDefault();
            this.props.onSelect(provider);
          }}
        >
          <i className="icon-globe" />
          <div className="provider-content-wrap">
            {provider.name}
            <span>{provider.url}</span>
          </div>
          <i className="icon-caret-right" />
        </a>
      </PoseItem>
    );
  };

  renderWeatherProviders = () => {
    if (this.props.providers.length === 0) {
      return (
        <div className="content">
          <div className="empty-wrap">
            <i className="icon-warning" />
            <span>{this.props.t("weather:no_providers")}</span>
          </div>
        </div>
      );
    }

    return (
      <PoseOverlay
        className="content menu-list-container"
        pose={this.state.isOpen ? "open" : "closed"}
      >
        {this.props.providers.map(provider =>
          this.renderWeatherProvider(provider)
        )}
      </PoseOverlay>
    );
  };

  render() {
    return (
      <div className="screen-container screen-weather">
        <ScreenHeader title={this.props.t('weather:screen_title')} />
        {this.renderWeatherProviders()}
      </div>
    );
  }
}

export default withNamespaces(["weather", "common"], { wait: true })(Weather);
